import { useCallback } from 'react';

import { PROMPT_INSTRUCTIONS_ACTION } from 'src/components/PromptInstructions';
import { MAX_RESOURCE_PER_TYPE } from 'src/data/common';
import { FEATURE_LIMITS } from 'src/data/featureLimits';
import { RESOURCE_CONTENT_TYPE } from 'src/data/performance';
import { useBrandVoicesActions, useCustomerActions } from 'src/store';
import { useBrandBriefPopup } from 'src/views/BrandBriefPopup';
import { useUpgradePopup } from 'src/views/UpgradePopup';

export const usePreparePromptInstructionsProps = ({
  uploadingImages = [],
  uploadingDocuments = [],
  currentUrls = [],
}) => {
  const customerActions = useCustomerActions();
  const brandVoicesActions = useBrandVoicesActions();
  const openUpgradePopup = useUpgradePopup();
  const openBrandBriefPopup = useBrandBriefPopup();

  const shouldOpenConfirmPopup = useCallback(
    (resourceTypes, id) => {
      // go over types and check if a file exists for one of the types
      for (const type of resourceTypes) {
        if (
          type === RESOURCE_CONTENT_TYPE.image &&
          uploadingImages.length === MAX_RESOURCE_PER_TYPE
        ) {
          return !id || !uploadingImages.some((image) => image.id === id);
        }
        if (
          type === RESOURCE_CONTENT_TYPE.document &&
          uploadingDocuments.length === MAX_RESOURCE_PER_TYPE
        ) {
          return !id || !uploadingDocuments.some((doc) => doc.id === id);
        }
        if (type === RESOURCE_CONTENT_TYPE.url && currentUrls.length === MAX_RESOURCE_PER_TYPE) {
          return true;
        }
      }
      return false;
    },
    [currentUrls.length, uploadingDocuments, uploadingImages]
  );

  const onAction = useCallback(
    (action, data = null) => {
      switch (action) {
        case PROMPT_INSTRUCTIONS_ACTION.addBrandBrief: {
          if (customerActions.featureLimitExceeded(FEATURE_LIMITS.brandBriefPerCustomer)) {
            openUpgradePopup(FEATURE_LIMITS.brandBriefPerCustomer);
            return;
          }

          const brandVoice = data?.brandVoice || brandVoicesActions.getDefaultBrandVoice();
          return openBrandBriefPopup({ brandVoice });
        }

        default:
          break;
      }
    },
    [brandVoicesActions, customerActions, openBrandBriefPopup, openUpgradePopup]
  );

  return {
    shouldOpenConfirmPopup,
    onAction,
  };
};
